import { capitalize, formatNaira } from "@/lib/utils";
import type { PaymentPlanCardProps } from "../types";

const frequencyUnit: Record<string, string> = {
  daily: "day",
  weekly: "week",
  monthly: "month",
};

export function PaymentPlanCard({ plan }: PaymentPlanCardProps) {
  const unit = frequencyUnit[plan.paymentFrequency] ?? plan.paymentFrequency;
  const durationLabel = `${plan.duration} ${unit}${plan.duration === 1 ? "" : "s"}`;

  return (
    <article className="group flex flex-col overflow-hidden rounded-cstm-card border border-green-2400 bg-white shadow-[0_1px_2px_rgba(2,28,13,0.04),0_8px_24px_-12px_rgba(2,28,13,0.12)] transition-shadow duration-300 hover:shadow-[0_1px_2px_rgba(2,28,13,0.05),0_16px_32px_-12px_rgba(2,28,13,0.2)]">
      <div className="p-4 sm:p-5">
        <div className="flex items-center justify-between gap-3">
          <h4 className="text-base font-semibold tracking-copy text-black-100 sm:text-lg">
            {plan.name}
          </h4>
          <span className="shrink-0 rounded-full border border-green-2400 bg-green-2000 px-2.5 py-1 text-xs font-medium text-green-2500">
            {capitalize(plan.paymentFrequency)}
          </span>
        </div>

        <p className="mt-3 flex items-baseline gap-1.5">
          <span className="text-2xl font-semibold tracking-copy text-black-100 sm:text-[28px]">
            {formatNaira(plan.intervalPayment)}
          </span>
          <span className="text-sm text-grey-200">/ {unit}</span>
        </p>

        <dl className="mt-4 space-y-2.5 border-t border-dashed border-border-2 pt-4 text-sm">
          <div className="flex items-center justify-between gap-3">
            <dt className="text-grey-200">Down payment</dt>
            <dd className="font-medium text-black-100">
              {formatNaira(plan.downPayment)}
            </dd>
          </div>
          <div className="flex items-center justify-between gap-3">
            <dt className="text-grey-200">Duration</dt>
            <dd className="font-medium text-black-100">{durationLabel}</dd>
          </div>
        </dl>
      </div>

      <div className="mt-auto flex items-center justify-between gap-3 border-t border-green-2400 bg-green-2300 px-4 py-3 sm:px-5">
        <span className="text-sm font-medium text-green-1700">Total</span>
        <span className="text-sm font-semibold tracking-copy text-primary sm:text-base">
          {formatNaira(plan.total)}
        </span>
      </div>
    </article>
  );
}
